import uuid from "uuid";

export const ASYNC_SAVE_MERCHANTEDIT = "kopaproLicense/merchantEdit/asyncSaveMerchant";
export const SAVE_MERCHANTEDIT_SUCCESS = "kopaproLicense/merchantEdit/saveMerchantSuccess";
export const ASYNC_EDIT_MERCHANTEDIT = "kopaproLicense/merchantEdit/asyncEditMerchant";
export const EDIT_MERCHANTEDIT_SUCCESS = "kopaproLicense/merchantEdit/editMerchantSuccess";
export const ASYNC_READ_MERCHANTEDIT = "kopaproLicense/merchantEdit/asyncReadMerchant";
export const READ_MERCHANTEDIT_SUCCESS = "kopaproLicense/merchantEdit/readMerchantSuccess";
export const CLEAR_MERCHANTEDIT = "kopaproLicense/merchantEdit/clearMerchant";
export const UPDATE_MERCHANTEDIT = "kopaproLicense/merchantEdit/updateMerchant";

export const initialState = {   
    email: '',
    firstName: '',
    lastName: '',
    enableSecAuth: false,
    compName: '',
    addr:'',
    addr2:'',
    zipCode:0,
    city:'',
    province:'',
    country:'',
    countryCode:0,
    areaCode:0,    
    tel:0,
    compCountryCode:0,
    compAreaCode:0,
    compTel:0,
    progCode:'',
    enableSecondAuth:false,
    password:'',
    repw:'',
    irev:0,
    licenses: [],
    formUuid: ''       
}

export default function reducer(state=initialState ,action){
    switch(action.type){        
        case READ_MERCHANTEDIT_SUCCESS:{
            return {
                ...state,
                ...action.payload,
                formUuid: uuid.v4()
            }
        }
        case EDIT_MERCHANTEDIT_SUCCESS:{
            return {
                ...state,
                ...action.payload                
            }
        }
        case CLEAR_MERCHANTEDIT:{
            return {
                ...initialState,

            }
        }
        case UPDATE_MERCHANTEDIT:{
            
            return {
                ...state,
                ...action.payload.data
            }
        }    
        default:            
        return state;
    }
}


export const updateMerchantEdit = (data) => ({
    type: UPDATE_MERCHANTEDIT, payload:{
        data
    }
})


export const asyncEditMerchantEdit = (data,callback) => ({
    type: ASYNC_EDIT_MERCHANTEDIT, payload:{
        data:data,
        callback: callback
    }
})

export const asyncSaveMerchantEdit = (callback,editMode) => ({
    type: ASYNC_SAVE_MERCHANTEDIT, payload:{     
        callback: callback,
        editMode: editMode
    }
})

export const readMerchantEdit = (code,callback) => ({
    type: ASYNC_READ_MERCHANTEDIT, payload:{
        code: code,
        callback: callback
    }
})

export const clearMerchantEdit = () => ({
    type: CLEAR_MERCHANTEDIT
})